// load bootstrap
require("bootstrap-sass!../bootstrap-sass.config.js");

// style
require('flexslider/flexslider.css');

require('./style/bsky_style.scss');



//////////////////
// WEBPACK FOOTER
// ./src/base.js
// module id = 2
// module chunks = 0 2 3 5 6